module.exports = __webpack_public_path__ + "static/media/principal@2x.6238bf9a.png";